

export default {
    layout: 'narrow',
}
